import { create } from "zustand";
import { persist } from "zustand/middleware";
import { getIsInternalFromToken, getRoleFromToken } from "../utils/auth";

const useAuthStore = create(
  persist(
    (set) => ({
      token: null,
      isInternal:true,
      setToken: (token) => set({
        token,
        role: getRoleFromToken(token),
        isInternal:getIsInternalFromToken(token)
      }),
      setIsInternal: (value) => set({ isInternal: value }),
      clearToken: () => set({ token: null, role: null }),
    }),
    {
      name: "auth-storage", // key in localStorage
    }
  )
);

export default useAuthStore;
